/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import React from 'react'

import { Can } from '@builddocs/data-management-casl'
import MenuRoundedIcon from '@mui/icons-material/MenuRounded'
import { Box, BoxProps, IconButton, Stack, Typography } from '@mui/material'

import LogoButton from '../header/atoms/LogoButton'
import ProjectsNavWidget from '../organisms/ProjectsNavWidget'

type SideNavigationProps = BoxProps & { onClose?: () => void }

export const SideNavigation = React.forwardRef<
  HTMLDivElement,
  SideNavigationProps
>((props, ref) => {
  const { onClose } = props

  return (
    <Box
      ref={ref}
      bgcolor="background.paper"
      component="aside"
      display="flex"
      flexDirection="column"
      height="100%"
      p={1}
      position="relative"
      sx={{
        borderRightColor: 'divider',
        borderRightWidth: '1px',
        borderRightStyle: 'solid',
        overflowY: 'auto',
      }}
      width="100%"
      {...props}
    >
      {!!onClose && (
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="flex-end"
          spacing={0.5}
          sx={{ width: 'fit-content', mb: 1 }}
        >
          <IconButton
            sx={{ width: 36, height: 36, mt: 0.25 }}
            onClick={onClose}
          >
            <MenuRoundedIcon sx={{ color: 'black' }} />
          </IconButton>
          <LogoButton onClick={onClose} />
        </Stack>
      )}
      <Can passThrough I="view" a="Contracts">
        {(can: boolean) =>
          can ? (
            <ProjectsNavWidget />
          ) : (
            <Typography fontWeight="bold" ml={1} variant="body1">
              Ваш список проектов пуст.
            </Typography>
          )
        }
      </Can>
    </Box>
  )
})

SideNavigation.displayName = 'SidePanel'

export default React.memo(SideNavigation)
